import { useAppStore } from "@/global/store";
import { selectCartManager } from "@/global/store/data/purchaseSeats/cartManager";
import {
  selectOrderServiceFee,
  selectServiceFeeTotal,
} from "@/global/store/data/purchaseSeats/serviceFee";
import {
  calculateAllCartMandatoryPerkCost,
  calculateAllCartNonMandatoryPerkCost,
} from "@/global/utils/utils";

export const useBackendSubtotals = () => {
  const cartManager = useAppStore(selectCartManager);
  const availableCredit = useAppStore((state) => {
    return state?.data?.creditReport?.availableCredit;
  });
  const serviceFeeTotalAmount = useAppStore(selectServiceFeeTotal);
  const orderServiceFee = useAppStore(selectOrderServiceFee);
  const mandatoryPerkCost = calculateAllCartMandatoryPerkCost(cartManager?.cart); // prettier-ignore
  const nonMandatoryPerkTotalAmount = calculateAllCartNonMandatoryPerkCost(cartManager?.cart); // prettier-ignore

  return {
    availableCredit,
    serviceFeeTotalAmount,
    orderServiceFee,
    mandatoryPerkCost,
    nonMandatoryPerkTotalAmount,
  };
};
